import { UserWMSFilterModel, UserWMSListModel } from '@kanzi-apes/kanzi-models';

export const UsersWMSQueryKeys = {
  all: (filters: UserWMSFilterModel | null) => ['userWMSList', filters],
};

export const UsersRolesWMSQueryKeys = {
  all: () => ['userRolesWMSList'],
}

export const UserConfigWMSQueryKeys = {
  all: (filters: UserWMSFilterModel | null) => ['userConfigWMSList', filters],
  getUrl: (filters: UserWMSFilterModel | null) => ['userConfigWMSUrl', filters],
}